import mutations from '@/store/modules/cloud/detail/detail.mutations';
import actions from '@/store/modules/cloud/detail/detail.actions';
import getters from '@/store/modules/cloud/detail/detail.getters';

export interface State {
  currentServiceInstance: String[];
  currentService: String;
  currentServices: Array<String>;
  currentPage: String;
  currentSubType: String;
  currentTab: String;
  clusterLabels: String[];
}

const state: State = {
  currentServiceInstance: [],
  currentService: '',
  currentServices:[],
  currentPage: 'overview',
  currentSubType: 'RDS_MYSQL',
  currentTab:'',
  clusterLabels: [],
};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
